import { AccessDeniedError, UnexpectedError } from "../../domain/errors";
import { UnauthorizedError } from "../../domain/errors/unauthorized-error";
import { Position } from "../../domain/models/position-model";
import { CreatePosition } from "../../domain/usecases/create-position";
import { HttpClient, HttpStatusCode } from "../protocols/http";

export class DbCreatePosition implements CreatePosition {
  constructor(
    private readonly url: string,
    private readonly httClient: HttpClient
  ) {}
  async create(position: Position): Promise<boolean> {
    const res = await this.httClient.request({
      url: this.url,
      method: "post",
      body: position,
    });
    switch (res.statusCode) {
      case HttpStatusCode.ok:
        return true;
      case HttpStatusCode.forbidden:
        throw new AccessDeniedError();
      case HttpStatusCode.unauthorized:
        throw new UnauthorizedError();
      default:
        throw new UnexpectedError();
    }
  }
}
